export default __webpack_public_path__ + "static/media/HDM.fe45de6d.png";